export const MenuItem = ({ children, ...props }: any) => <li {...props}>{children}</li>;
